<template>
    <v-container>
        <v-layout v-if="!showInstaller" wrap xs12>
            <v-flex xs12>
            <v-flex style="font-weight: bold; font-size: 16px" xs4>
                Please check our support article below for more details on why you are seeing this page.  
                <p></p>
            </v-flex>
            </v-flex>
            <v-flex style="font-weight: bold; font-size: 16px">
        <a :href="brandingService.getSupportUrl('adminGuide')" target="_blank">Admin Guide</a>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="showInstaller">
            <v-flex xs10>
            <collector-install-panel mode="install"></collector-install-panel>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import BrandingService from '../../../../services/branding.service';
import CollectorInstallPanel from './CollectorInstallPanel.vue';
export default {
    data: () => { 
        return {
            brandingService: BrandingService,
        };
    },
    components: {
        'collector-install-panel': CollectorInstallPanel
    },
    computed: { 
        ...mapGetters('user', {
            appConfigs: 'getAppConfigs'
        }),
        showInstaller: {
            get() {
                if (!this.appConfigs) {
                    return false
                }
                var appConfig = _.find(this.appConfigs, (config) => {
                    return config.parameter && config.parameter.key === 'enableGetStarted'
                })

                return appConfig && appConfig.value === 'true'
            }
        }
    }
}
</script>
